import useAdControlBanner from './useAdControlBanner';
import useAdControlNative from './useAdControlNative';

export { useAdControlNative, useAdControlBanner };
